<h2 mat-dialog-title class="error-title">{{ data.title || 'Error' }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.link) {
    <button mat-raised-button color="primary" (click)="openLink()">
      {{ data.linkText || 'Open Link' }}
    </button>
  }
  <button mat-raised-button class="button" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
